import { _ } from "svelte-i18n";

let i18n;

const loadi18n = () => {
  _.subscribe((store) => {
    i18n = store;
  });
};

loadi18n();

export function isEmail(value) {
  const result = /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/.test(
    value,
  );
  return [result, i18n("^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,})$")];
}

export function isValidName(value, maxCharacters = 50) {
  const maxLength = value.length > maxCharacters;
  if (maxLength)
    return [false, i18n("validation.length", { values: { maxCharacters } })];
  const regexTest =
    /^(?!^\s+$)[A-Za-zöäüß\s'-]*[A-Za-zöäüß][A-Za-zöäüß\s'-]*$/.test(value);
  if (!regexTest)
    return [
      false,
      i18n("^(?!^s+$)[A-Za-zöäüßs'-]*[A-Za-zöäüß][A-Za-zöäüßs'-]*$"),
    ];
}

export function isValidNameWithSpaces(value) {
  const regexTest =
    /^(?!^\s*$)[A-Za-zöäüß\s'-]*[A-Za-zöäüß][A-Za-zöäüß\s'-]*$/.test(value);
  if (!regexTest)
    return [
      false,
      i18n("^(?!^s*$)[A-Za-zöäüßs'-]*[A-Za-zöäüß][A-Za-zöäüßs'-]*$"),
    ];
}

export function isValidNameWithSpacesAndNumbers(value) {
  const regexTest =
    /^(?!^\s*$)[A-Za-z0-9öäüß\s'-]*[A-Za-zöäüß][A-Za-z0-9öäüß\s'-]*$/.test(
      value,
    );
  if (!regexTest)
    return [
      false,
      i18n("^(?!^s*$)[A-Za-z0-9öäüßs'-]*[A-Za-zöäüß][A-Za-z0-9öäüßs'-]*$"),
    ];
}

export function isValidNameWithoutSpace(value) {
  const regex = new RegExp("^[a-zA-Z0-9_-]{1,35}$");
  const result = regex.test(value);
  return [result, i18n("^[a-zA-Z0-9_-]{1,35}$")];
}

export function isValidDescription(value) {
  const result = /^[a-zA-Z0-9\s.,!?()-]{0,150}$/.test(value);
  return [result, i18n("^[a-zA-Z0-9s.,!?()-]{1,150}$")];
}
